import React, { useState, useEffect, useRef } from 'react'
import {
  Box,
  Heading,
  Text,
  Button,
  TextInput,
  RadioButtonGroup, //as RadioButtonGroupG,
} from 'grommet'
// import { Group } from 'grommet-icons'
import styled from 'styled-components'
import { EventGA } from '../../utils/GaEvent'
import { useDispatch, useSelector } from 'react-redux'
// import { CSVLink } from 'react-csv'
import {
  groupPeople,
  clearAllGroups,
  changeNumGroups,
  openBoardModal,
  setEvenSplit,
  setShowIcon,
  setPickQuantity,
  setPickRepresentative,
} from '../../redux/rtg/actions'
// import { displayCustomTeamModal } from '../../redux/modal/actions'
import SpinningWheel from '../Spinner/SpinningWheel'
import { transparentize } from 'polished'
import * as Audio from '../ReactTurntable/TurntableSounds'
import { useDarkMode } from '../../contextHook/darkMode'
// import TooltipButton from '../Button/TooltipButton'
import NewWrapper from '../NewWrapper'
import { useAsyncDispatch } from '../../hook/useAsync'
import InfoButton from '../Button/InfoButton'
import { replaceCDN } from '../../utils'
import { usePersistValue } from '../../hook/usePersistValue'
import { setIsToolSpinning } from '../../redux/common/actions'
import TipDrop from '../Button/TipDrop'
import { isMobile } from 'react-device-detect'
import { CheckBox } from '../Common'

const Container = styled(Box)`
  padding: 1rem;
  /* border: 3px solid ${props => props.theme.global.colors.border}; */
  box-shadow: 0px 0px 2px 1px ${props => props.theme.global.colors.border};
  border-radius: 1rem;
`

// const IconButton = styled(Box)`
//   cursor: pointer;
// `

const NumInput = styled(TextInput)`
  height: 3rem;
  width: 6.2rem;
  border: 2px solid ${props => props.theme.global.colors.border};
  text-align: center;
`

const StartButton = styled(Button)`
  /* border: ${props => props.theme.global.colors.secondary}; */
  background-color: ${props => props.toolColor};
  color: ${props => props.theme.global.colors.white};
  border-radius: 3px;

  @media (hover: hover) {
    &:hover {
      background-color: ${props => props.toolColor};
      box-shadow: none;
      box-shadow: ${props =>
        !props.disabled && `0px 0px 0px 2px ${props.toolColor}`};
      color: white;
    }
  }
  @media (hover: none) {
    &:hover {
      box-shadow: none;
    }
  }
`

const DownloadButton = styled(Button)`
  /* border: 3px solid ${props => props.theme.global.colors.primary}; */
  pointer-events: ${props => props.disabled && 'none'};
  background-color: ${props =>
    props.toolcolor !== '' &&
    (props.disabled ? transparentize(0.7, props.toolcolor) : props.toolcolor)};
  color: white;
  text-align: center;
  text-decoration: none;
  padding: 8px 22px;
  line-height: 24px;
  font-size: 18px;
  border-radius: 3px;
  font-weight: 700;
  &:active,
  &:focus {
    /* border: 3px solid ${props => props.theme.global.colors.primary}; */
    background-color: ${props =>
      props.toolcolor !== '' &&
      (props.disabled
        ? transparentize(0.7, props.toolcolor)
        : props.toolcolor)};
    color: white;
  }
  &:hover {
    /* border: 5px solid ${props => props.theme.global.colors.primary}; */
    background-color: ${props =>
      props.toolcolor !== '' &&
      (props.disabled
        ? transparentize(0.7, props.toolcolor)
        : props.toolcolor)};
    box-shadow: ${props =>
      !props.disabled && `0px 0px 0px 2px ${props.toolcolor}`};
    color: white;
  }
`

const DeleteAllButton = styled(Button)`
  border: 0px solid #fff;
  background-color: transparent;
  color: ${props => props.theme.global.colors.text};
  text-align: center;
  text-decoration: none;

  line-height: 24px;
  font-size: 16px;
  font-weight: 700;
  &:active,
  &:focus {
    /* border: 3px solid ${props => props.theme.global.colors.primary}; */
    color: ${props => props.toolColor};
  }
  &:hover {
    /* border: 5px solid ${props => props.theme.global.colors.primary}; */
    color: ${props => props.toolColor};
    text-decoration: ${props => !props.disabled && 'underline'};
    box-shadow: none;
  }
`

// const RadioButtonGroup = styled(RadioButtonGroupG)`
//   & label div input {
//     &:hover {
//       & + div {
//         border-color: ${props => props.toolColor} !important;
//       }
//     }
//     & + div:has(svg) {
//       border-color: ${props => props.toolColor} !important;
//       & svg {
//         fill: ${props => props.toolColor};
//       }
//     }
//   }
// `

const Controller = ({ onStart }) => {
  const evenlyPersist = useSelector(state => state.rtg.evenSplit)
  const [evenly, setEvenly] = useState('Default')
  const groupNumPersist = useSelector(state => state.rtg.numGroups)
  const [groupNum, setGroupNum] = useState(2)
  const [pastGroupNum, setPastGroupNum] = useState(2)
  const [peopleNum, setPeopleNum] = useState(1)
  const [pastPeopleNum, setPastPeopleNum] = useState(1)
  // const { value: pickQuantityValue } = usePersistValue(
  //   state => state.rtg.pickQuantity,
  // )
  const pickQuantityValue = useSelector(state => state.rtg.pickQuantity)
  // const [pickQuantityValue, setPickQuantityValue] = useState(0)
  const prevPeopleLength = useRef(0)
  const changeStatusModified = useRef(false)
  const showIconPersist = useSelector(state => state.rtg.showIcon)
  const [showIcon, setShowIconInner] = useState(true)
  // const [mode, setMode] = useState('Default')
  // const [prevPeopleLength, setPrevPeopleLength] = useState(0)
  // const [spinCount, setSpinCount] = React.useState(0)
  // const people = useSelector(state => state.rtg.people)
  const peoplePersist = useSelector(state => state.rtg.people)
  const [people, setPeople] = useState([])
  const csvGroups = useSelector(state => state.rtg.csvGroups)
  const music = useSelector(state => state.settings.music)
  // const spinning = useSelector(state => state.async.loading)
  const toolColorsPersist = useSelector(
    state => state.settings.wheelColors.colors,
  )
  const [toolColors, setToolColors] = useState(['', '', '', ''])
  const { value: pickRepresentative } = usePersistValue(
    state => state.rtg.pickRepresentative,
  )
  const [hasSpinOnce, setHasSpinOnce] = useState(false)
  const isToolSpinning = useSelector(state => state.common.isToolSpinning)
  const { value: darkMode } = useDarkMode()
  const { execute: groupPeopleAsync, loading: spinning } =
    useAsyncDispatch(groupPeople)
  const dispatch = useDispatch()
  // const [audioStart, setAudioStart] = useState(Audio.startingSounds[1].value)
  // const [audioSpinning, setAudioSpinning] = useState(
  //   Audio.spinningSounds[1].value,
  // )
  // const [audioCelebrate, setAudioCelebrate] = useState(
  //   Audio.endingSounds[1].value,
  // )
  const onKeyDown = event => {
    if (event.key === 'Enter' && event.ctrlKey) {
      event.preventDefault()
      if (!isToolSpinning) {
        startGrouping()
      }
    }
  }
  useEffect(() => {
    if (!isMobile) {
      document.addEventListener('keydown', onKeyDown)
      return () => {
        document.removeEventListener('keydown', onKeyDown)
      }
    }
  }, [people, groupNum, pickQuantityValue, pickRepresentative, isToolSpinning])

  useEffect(() => {
    Audio.preloadSound(replaceCDN(music.starting), 'starting')
    Audio.preloadSound(replaceCDN(music.spinning), 'spinning')
    Audio.preloadSound(replaceCDN(music.celebrating), 'ending')
    // Audio.preloadSounds(music.starting, music.spinning, music.celebrating)
  }, [music.starting, music.spinning, music.celebrating])

  useEffect(() => {
    setToolColors(toolColorsPersist)
  }, [toolColorsPersist])

  useEffect(() => {
    if (showIconPersist !== showIcon) {
      setShowIconInner(showIconPersist)
    }
  }, [showIconPersist])

  useEffect(() => {
    const filteredPeople = peoplePersist.filter(
      person => person.filtered === undefined || person.filtered === false,
    )
    setPeople(filteredPeople)
    if (groupNum > 0) {
      setPeopleNum(Math.ceil(filteredPeople.length / groupNum))
    }
    if (prevPeopleLength.current !== filteredPeople.length) {
      if (prevPeopleLength.current === pickQuantityValue) {
        dispatch(setPickQuantity(filteredPeople.length))
      }
    }
    prevPeopleLength.current = filteredPeople.length
  }, [peoplePersist])

  useEffect(() => {
    if (groupNumPersist !== groupNum) {
      setGroupNum(groupNumPersist)
    }
  }, [groupNumPersist])

  useEffect(() => {
    if (evenlyPersist !== evenly) {
      setEvenly(evenlyPersist)
    }
  }, [evenlyPersist])

  useEffect(() => {
    if (groupNum === '') return
    const timeOutId = setTimeout(async () => {
      let tempGroupNum = groupNum
      if (groupNum <= 0) {
        tempGroupNum = pastGroupNum
      } else {
        setPastGroupNum(tempGroupNum)
      }
      setGroupNum(tempGroupNum)
      const tempPeopleNum = Math.ceil(pickQuantityValue / tempGroupNum)
      if (tempPeopleNum !== peopleNum) {
        setPeopleNum(tempPeopleNum)
      }
      await dispatch(
        changeNumGroups(tempGroupNum, changeStatusModified.current),
      ) // changestatusmodified needed, because loadsave will make it modified
      changeStatusModified.current = false
    }, 200)
    return () => clearTimeout(timeOutId)
  }, [groupNum, pickQuantityValue])

  useEffect(() => {
    if (peopleNum === '') return
    const timeOutId = setTimeout(() => {
      let tempPeopleNum = peopleNum
      if (peopleNum <= 0) {
        tempPeopleNum = pastPeopleNum
      } else {
        setPastPeopleNum(tempPeopleNum)
      }
      setPeopleNum(tempPeopleNum)
    }, 200)
    return () => clearTimeout(timeOutId)
  }, [peopleNum])

  const celebrate = () => {
    if (music.soundOn) {
      Audio.pauseSound('spinning')
    }
    dispatch(openBoardModal(1))
    if (music.soundOn) {
      Audio.playSound('ending')
    }
  }

  const startGrouping = async () => {
    dispatch(setIsToolSpinning(true))
    dispatch(openBoardModal(0))
    if (people.length === 0) {
      return
    }
    if (groupNum === '') {
      return
    }
    if (music.soundOn) {
      Audio.playSound('starting')
      Audio.playSound('spinning', true)
    }
    onStart()
    EventGA({
      category: 'RTG Actions',
      action: 'RTG Start Grouping',
    })
    await groupPeopleAsync(
      people,
      groupNum,
      celebrate,
      pickQuantityValue,
      pickRepresentative,
    )
    // dispatch(groupPeople(groupNum, celebrate))
    setHasSpinOnce(true)
    dispatch(setIsToolSpinning(false))
  }

  return (
    <Box align="stretch">
      {spinning ? (
        <SpinningWheel toolColors={toolColors} />
      ) : (
        <>
          <Container align="stretch" gap="1rem" background="baseBackground">
            <Box
              direction="row"
              justify="between"
              align="center"
              margin={{ bottom: '1.0rem' }}
            >
              <Heading level={3} margin="0">
                2. CONTROLLER
              </Heading>
              {/* <NewWrapper date="2021-09-21">
                <TooltipButton
                  icon={<Group color="secondary" size="small" />}
                  clicked={() => dispatch(displayCustomTeamModal(true))}
                  message="Set Team Names"
                  position="top"
                  color="secondary"
                />
              </NewWrapper> */}
            </Box>
            <Box gap="1.5rem" align="stretch">
              <Box justify="between">
                <Text>Distribute equally based on:</Text>
                <RadioButtonGroup
                  direction="row"
                  // toolColor={
                  //   !darkMode || toolColors.length < 3
                  //     ? toolColors[0]
                  //     : toolColors[2]
                  // }
                  name="balanceDistribution"
                  options={['Default', 'Gender', 'Label']}
                  value={evenly}
                  onChange={event => {
                    const tempEvenly = event.target.value
                    dispatch(setEvenSplit(tempEvenly))
                    if (
                      pickQuantityValue !== people.length &&
                      tempEvenly !== 'Default'
                    ) {
                      dispatch(setPickQuantity(people.length))
                    }
                  }}
                />
                {/* <CheckBox
                  checked={evenly}
                  onChange={event => {
                    dispatch(setEvenSplit(event.target.checked))
                  }}
                  size={size}
                /> */}
              </Box>
              {evenly !== 'Default' && (
                <CheckBox
                  reverse
                  fill
                  checked={showIcon}
                  // activeColor={
                  //   !darkMode || toolColors.length < 3
                  //     ? toolColors[0]
                  //     : toolColors[2]
                  // }
                  label={`Show ${evenly.toLowerCase()} in result?`}
                  onChange={event => {
                    const checked = event.target.checked
                    dispatch(setShowIcon(checked))
                    setShowIconInner(checked)
                  }}
                  size="3rem"
                />
              )}

              {evenly === 'Default' && (
                <Box direction="row" align="center">
                  <Text>Pick quantity</Text>
                  <InfoButton content="Decide how many inputs will be randomly arranged for grouping. Only available in Default mode." />
                  <Box
                    direction="row"
                    align="center"
                    gap=".5rem"
                    margin={{ left: 'auto' }}
                  >
                    <NumInput
                      disabled={evenly !== 'Default'}
                      type="number"
                      min={0}
                      max={people.length}
                      value={pickQuantityValue}
                      onChange={event => {
                        dispatch(setPickQuantity(event.target.value))
                      }}
                    />
                    / <Text>{people.length}</Text>
                  </Box>
                </Box>
              )}
              <Box>
                <Box direction="row" justify="between" align="center">
                  <Text>Number of groups</Text>
                  <Box>
                    <NumInput
                      type="number"
                      min={1}
                      max={pickQuantityValue}
                      value={groupNum}
                      onChange={event => {
                        const tempGroupNum = event.target.value
                        setGroupNum(tempGroupNum)
                        if (tempGroupNum > 0) {
                          setPeopleNum(
                            Math.ceil(pickQuantityValue / tempGroupNum),
                          )
                        }
                        changeStatusModified.current = true
                      }}
                    />
                  </Box>
                </Box>
                <Text size="1.4rem">OR (Set either one)</Text>
                <Box direction="row" justify="between" align="center">
                  <NewWrapper date="2021-09-21" top="-1rem">
                    <Text>Max people/group</Text>
                  </NewWrapper>
                  <Box>
                    <NumInput
                      type="number"
                      min={1}
                      max={pickQuantityValue}
                      value={peopleNum}
                      onChange={event => {
                        const tempPeopleNum = event.target.value
                        setPeopleNum(tempPeopleNum)
                        if (tempPeopleNum > 0) {
                          setGroupNum(
                            Math.ceil(pickQuantityValue / tempPeopleNum),
                          )
                        }
                        changeStatusModified.current = true
                      }}
                    />
                  </Box>
                </Box>
              </Box>
              <CheckBox
                reverse
                fill
                checked={pickRepresentative}
                // activeColor={
                //   !darkMode || toolColors.length < 3
                //     ? toolColors[0]
                //     : toolColors[2]
                // }
                label="Pick representatives?"
                onChange={event => {
                  const checked = event.target.checked
                  dispatch(setPickRepresentative(checked))
                }}
                size="3rem"
              />
            </Box>

            <Box margin={{ top: '2rem' }}>
              <TipDrop
                content="or press Ctrl+Enter"
                position="bottom"
                disabled={hasSpinOnce}
              >
                <StartButton
                  primary
                  disabled={people.length === 0}
                  toolColor={toolColors[1]}
                  onClick={startGrouping}
                  label="START"
                ></StartButton>
              </TipDrop>
            </Box>
          </Container>
          <Box gap=".5rem" margin={{ top: '2rem' }}>
            <DownloadButton
              // filename={"groupedByTeamPickerWheel.csv"}
              toolcolor={
                !darkMode || toolColors.length < 3
                  ? toolColors[0]
                  : toolColors[2]
              }
              // data={csvGroups}
              onClick={() => {
                dispatch(openBoardModal(2))
                EventGA({
                  category: 'RTG Actions',
                  action: 'RTG Open Board',
                })
              }}
              disabled={csvGroups.length === 0}
            >
              Open Groups Board
            </DownloadButton>
            <DeleteAllButton
              toolcolor={
                !darkMode || toolColors.length < 3
                  ? toolColors[0]
                  : toolColors[2]
              }
              label="Remove All Groups"
              disabled={csvGroups.length === 0}
              onClick={() => {
                dispatch(clearAllGroups())
                EventGA({
                  category: 'RTG Actions',
                  action: 'RTG Clear Result',
                })
              }}
            />
          </Box>
        </>
      )}
    </Box>
  )
}

export default Controller
